import React from 'react'

export const BoxHeader2 = React.forwardRef<HTMLDivElement, React.HTMLProps<HTMLDivElement>>((props, ref) => {
  const { className, ...rest } = props
  return <div ref={ref} className={`px-8 py-5 flex ${className}`} {...rest}>
    {props.children}
  </div>
})